export default __webpack_public_path__ + "static/media/gift-card-404.ba6ebcfa.svg";